import React, { useRef, useState } from 'react'
import { Table } from './Table';
import { emptyAssignment, Form, IAssignment } from './Form';
import { IPermissionProps } from '../../models/Login';
import { Toast } from 'primereact/toast';


export interface IModal {
    singleData: IAssignment,
    open: boolean
}

export const Assignments = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: emptyAssignment, open: false });
    };

    return (
        <div>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload} setReload={setReload} />
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Toast ref={toast} />

        </div>
    )
}
